import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../services/category.service';
import { PrizeCategory } from '../services/model/category';
import { Gift } from '../services/model/gift';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
})
export class CategoryComponent implements OnInit {
  categories: PrizeCategory[] = [];
  newCategoryName = '';
  showForm = false;
  loading = false;

  // új ajándék adatok kategória szerint
  newGifts: { [categoryName: string]: Gift } = {};

  constructor(private categoryService: CategoryService) {}

  ngOnInit(): void {
    this.loadCategories();
  }

  loadCategories(): void {
    this.loading = true;
    this.categoryService.getAllCategories().subscribe({
      next: (data) => {
        this.categories = data;
        // új ajándék mezők inicializálása
        this.newGifts = {};
        for (const category of data) {
          this.newGifts[category.categoryName] = { name: '', imgSrc: '', remaining: 1 };
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  toggleForm(): void {
    this.showForm = !this.showForm;
  }

  createCategory(): void {
    if (!this.newCategoryName.trim()) return;

    this.categoryService.createCategory(this.newCategoryName).subscribe(() => {
      this.newCategoryName = '';
      this.showForm = false;
      this.loadCategories();
    });
  }

  addGift(categoryName: string): void {
    const gift = this.newGifts[categoryName];

    if (!gift || !gift.name.trim() || !gift.imgSrc.trim() || gift.remaining <= 0) {
      alert('Minden mezőt helyesen ki kell tölteni.');
      return;
    }

    this.categoryService.addGift(categoryName, gift).subscribe(() => {
      this.loadCategories();
    });
  }

  deleteGift(categoryName: string, gift: Gift): void {
    if (confirm(`Biztosan törlöd ezt az ajándékot: "${gift.name}"?`)) {
      this.categoryService.deleteGift(categoryName, gift).subscribe(() => {
        this.loadCategories();
      });
    }
  }
}
